<style scoped>
  .index {
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    text-align: center;
    background: #0c1b2e;
  }

  .content {
    height: calc(100vh - 80px);
    display: flex;
  }

  .seamless-warp {
    height: calc(100% - 120px);
    overflow: hidden;
    color: #fff;
    background: #1a2738;
    margin-right: 20px;
    position: absolute;
    z-index: 1;
    width: calc(100% - 40px);
  }

  p {
    text-align: center;
    padding: 0px;
  }

  .seamless-warp ul {
    margin-left: 0px;
    margin-block-start: 0px;
    padding: 0px;
  }

  .header {
    height: 80px;
    background: url("/static/img/heder_bg.png");
    background-size: 100%;
    background-repeat: no-repeat;
  }

  .header .t-title {
    width: 100%;
    height: 100%;
    text-align: center;
    font-size: 2em;
    line-height: 80px;
    color: #ffffff;
    /*text-shadow: 1px 9px 4px #2d80ec;*/
  }

  .info {
    height: 300px;
  }

  .map {
    height: calc(100% - 300px);
  }

  .block-item {
    border: 1px solid #2c58a6;
    box-shadow: 0 0 10px #2c58a6;
    width: calc(100% - 40px);
    margin-left: 20px;
    height: calc(50% - 60px);
    margin-top: 30px;
    position: relative;
  }

  .block-item .line-box {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .block-item .line-box i.l-t-line {
    width: 5px;
    height: 24px;
    left: -3px;
    top: -3px;
  }

  .block-item .line-box i.t-l-line {
    height: 5px;
    width: 26px;
    left: -3px;
    top: -3px;
  }

  .block-item .line-box i.t-r-line {
    height: 5px;
    width: 26px;
    right: -3px;
    top: -3px;
  }

  .block-item .line-box i.r-t-line {
    width: 5px;
    height: 24px;
    right: -3px;
    top: -3px;
  }

  .block-item .line-box i.l-b-line {
    width: 5px;
    height: 24px;
    left: -3px;
    bottom: -3px;
  }

  .block-item .line-box i.b-l-line {
    height: 5px;
    width: 26px;
    left: -3px;
    bottom: -3px;
  }

  .block-item .line-box i.r-b-line {
    width: 5px;
    height: 24px;
    right: -3px;
    bottom: -3px;
  }

  .block-item .line-box i.b-r-line {
    height: 5px;
    width: 26px;
    right: -3px;
    bottom: -3px;
  }

  .block-item .line-box i {
    background-color: #4788fb;
    box-shadow: 0 0 10px #4788fb;
    position: absolute;
  }

  .lajiinfo {
    color: #fff;
    font-size: 16px;
    text-align: left;
  }

  .record-img {
    width: 40px;
    height: 40px;
    cursor: pointer;
  }

  .d-flex {
    display: flex;
  }

  .flex-1 {
    flex: 1;
  }

  .flex-2 {
    flex: 2;
  }

  .table-header {
    background: #31445d;
    color: rgb(105, 233, 255);
    margin-right: 20px;
    height: 44px;
    line-height: 44px;
    padding: 0px;
    border-bottom: 1px solid #000c17;
    border-radius: 5px 5px 0px 0px;
  }


  .num-info p {
    width: 100%;
    text-align: left;
    line-height: 24px;
    font-size: 20px;
  }

  @-webkit-keyframes masked-animation {
    0% {
      background-position: 0 0;
    }
    100% {
      background-position: -100% 0;
    }
  }

  .num-info {
    color: rgb(228, 228, 228);
    margin: 66px 0px 0px 20px;
  }

  @media (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {

    /*.t-title span{*/
    /*  -webkit-text-fill-color: transparent;*/
    /*  -webkit-background-clip: text;*/
    /*  -webkit-background-size: 200% 100%;*/
    /*  background-image: -webkit-linear-gradient(left, #0ee5ff, #f4ab20 50%, #0ee5ff 50%, #f4ab20 100%, #0ee5ff);*/
    /*  -webkit-animation: masked-animation 3s infinite linear;*/
    /*}*/
  }

  .num-info .num {
    color: #69e9ff;
    font: 24px/18px 'ds-digitalbold';
  }

  .pies .pie {
    margin: 23px 20px 0px 0px;
    width: 120px;
    height: 120px;
  }

  ul li {
    background-color: #1a2738;
    height: 50px;
    line-height: 50px;
    padding: 0px;
    color: #2dbfd8;
  }

  ul li img {
    width: 40px;
    height: 40px;
    cursor: pointer;
  }

  ul li:nth-child(2n+1) {
    background-color: #243448;
  }

  .b-map {
    z-index: 1 !important;
  }

  .box-a .m-25 {
    width: 160px;
    height: 160px;
    z-index: 40;
    filter: alpha(opacity=50); /*支持 IE 浏览器*/
    -moz-opacity: 0.50; /*支持 FireFox 浏览器*/
    opacity: 0.50; /*支持 Chrome, Opera, Safari 等浏览器*/
    position: absolute; /*绝对定位*/
    top: 740px;
    left: 550px;
  }

  .m-25k {
    width: 160px;
    height: 160px;
    position: absolute; /*绝对定位*/
  }

  .m-25zt1 {
    width: 160px;
    height: 30px;
    border-bottom: 1px solid #000;
    padding-bottom: 3px;
    margin: 55px auto 0 auto;
    color: #19a9da;
    font: 18px/36px '楷体';
    text-align: center;
  }

  .m-25zt2 {
    width: 160px;
    height: 50px;
    margin-top: 8px;
    color: #9C0;
    font: 30px/30px 'ds-digitalbold';
    text-align: center;
  }

  .m-25k .m-25xz1 {
    width: 160px;
    height: 160px;
    z-index: 41;
    position: absolute; /*绝对定位*/
    bottom: 0px;
    right: 0px;
    -webkit-background-size: 160px 80px;
    -moz-background-size: 160px 80px;
    background-size: 160px 160px;
    -webkit-border-radius: 80px;
    border-radius: 80px;
  }

  .m-25pic1 {
    background: no-repeat url("/static/img/gif-14-1.png") left top;
    -moz-transition: all .1s;
    -webkit-transition: all .1s;
    transition: all .1s;
    -moz-animation: rotate 1s infinite linear;
    -webkit-animation: rotate 1s infinite linear;
    animation: rotate 1s infinite linear;
  }

  .m-25pic2 {
    background: no-repeat url("/static/img/gif-14-2.png") left top;
    -moz-transition: all .1s;
    -webkit-transition: all .1s;
    transition: all .1s;
    -moz-animation: rotate 1s infinite linear;
    -webkit-animation: rotate 1s infinite linear;
    animation: rotate 1s infinite linear;
  }

  .m-25pic3 {
    background: no-repeat url("/static/img/gif-14-3.png") left top;
    -moz-transition: all .1s;
    -webkit-transition: all .1s;
    transition: all .1s;
    -moz-animation: rotate 1s infinite linear;
    -webkit-animation: rotate 1s infinite linear;
    animation: rotate 1s infinite linear;
  }

  .m-25pic4 {
    background: no-repeat url("/static/img/gif-14-4.png") left top;
    -moz-transition: all .1s;
    -webkit-transition: all .1s;
    transition: all .1s;
    -moz-animation: rotate 1s infinite linear;
    -webkit-animation: rotate 1s infinite linear;
    animation: rotate 1s infinite linear;
  }

  @-moz-keyframes rotate {
    100% {
      -moz-transform: rotate(0deg);
    }
    100% {
      -moz-transform: rotate(360deg);
    }
  }

  @-webkit-keyframes rotate {
    100% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes rotate {
    100% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }



</style>
<template>
  <div class="index">
    <div class="header">
      <div class="t-title">
        <span>{{province}}{{city}}垃圾分类数据大屏</span>
      </div>
      <div style="position: absolute;right: 24px;color: #fff;top: 31px;">
        <a href="#/home" @click="goMain">进入后台管理</a>
      </div>
    </div>
    <div class="content">
      <div class="block" style="flex: 1">
        <div style="height: 20px;text-align: left;padding-left: 20px">
         <span style="color: #fff">
        {{text}}
        <a-cascader :style="{width: '200px'}" :options="options" @change="onCityChange">
          <a href="#">选择省市</a>
        </a-cascader>
              <select v-if="streetList.length >0" placeholder="选择小区" style="color: #000" @change="changeStreet">
                <option value="">选择小区</option>
                <option v-for="item of streetList" :value="item.id">{{item.name}}</option>
              </select>
         </span>
        </div>
        <div class="block-item">
          <div style="margin: 20px 0px 0px 20px">
            <div class="d-flex lajiinfo">
              <p style="margin-left: 5px;color: #e4e4e4;font-size: 18px;">
                <Icon style="color: rgb(105, 233, 255); font-size: 18px;" type="container"/>
                <span style="margin-left: 5px">当前易腐垃圾信息</span></p>
              <p class="flex-1"></p>
              <p style="margin-right: 30px"><span style="color: #69e9ff">累计参与人次：</span>
                <span style="font-size: 18px;font-weight: bold">{{totalNum}}</span></p>
            </div>
            <div class="table-header d-flex">
              <p class="flex-1">地区</p>
              <p class="flex-1">小区</p>
              <p class="flex-1">门牌号</p>
              <p class="flex-1">重量</p>
              <p class="flex-1">图片</p>
              <p class="flex-1">上传时间</p>
            </div>
            <scroll :key="scrollKey" class="seamless-warp" :data="listData">
              <ul class="item">
                <li class="d-flex" v-for="item in listData">
                  <p class="flex-1">{{item.areaStr}}</p>
                  <p class="flex-1">{{item.streetName}}</p>
                  <p class="flex-1">{{item.doorNo}}</p>
                  <p class="flex-1">{{item.weight}}</p>
                  <p class="flex-1">
                    <img class="record-img" @click="showImg(item)" :src="item.imgs[0] || 'http://ima.anyuhuanjing.com/upimgs/caijiimgs/201912/1348/15751607983596.jpeg'" alt="">
                  </p>
                  <p class="flex-1" v-text="item.date"></p>
                </li>
              </ul>
            </scroll>
          </div>
          <div class="line-box"><i class="t-l-line"></i> <i class="l-t-line"></i></div>
          <div class="line-box"><i class="t-r-line"></i> <i class="r-t-line"></i></div>
          <div class="line-box"><i class="l-b-line"></i> <i class="b-l-line"></i></div>
          <div class="line-box"><i class="r-b-line"></i> <i class="b-r-line"></i></div>
        </div>

        <div class="block-item" id="myChart" ref="chartDiv">
          <div style="margin: 20px 0px 0px 20px;position: absolute;width: 100%;z-index: 1;">
            <div class="d-flex lajiinfo">
              <p style="margin-left: 5px;color: #e4e4e4;font-size: 18px;">
                <Icon style="color: rgb(105, 233, 255); font-size: 18px;" type="area-chart"/>
                <span style="margin-left: 5px">生活垃圾周趋势图</span></p>
              <p class="flex-1"></p>
              <p style="margin-right: 30px">
                <a-date-picker placeholder="选择年月日" @change="onDateChange">
                  <span style="color: #69e9ff;cursor: pointer">{{chartDate?chartDate:'选择年月日'}}</span>
                </a-date-picker>
              </p>
            </div>
            <div style="width: calc(100% - 40px);height: calc(100% - 50px)">
              <apexchart type=area v-if="chartHeight>0" :height="chartHeight" :options="chartOptions" :series="series"/>
            </div>
          </div>
          <div class="line-box"><i class="t-l-line"></i> <i class="l-t-line"></i></div>
          <div class="line-box"><i class="t-r-line"></i> <i class="r-t-line"></i></div>
          <div class="line-box"><i class="l-b-line"></i> <i class="b-l-line"></i></div>
          <div class="line-box"><i class="r-b-line"></i> <i class="b-r-line"></i></div>
        </div>
      </div>


      <div class="block" style="flex: 2;margin-top: 20px;">
        <div class="block-item" style="height: 200px">
          <div class="line-box"><i class="t-l-line"></i> <i class="l-t-line"></i></div>
          <div class="line-box"><i class="t-r-line"></i> <i class="r-t-line"></i></div>
          <div class="line-box"><i class="l-b-line"></i> <i class="b-l-line"></i></div>
          <div class="line-box"><i class="r-b-line"></i> <i class="b-r-line"></i></div>
          <div class="line-box d-flex">
            <div class="num-info flex-2">

              <!--              <div class="m-25">-->
              <!--              <div class="m-25k">-->
              <!--                <div class="m-25xz1 m-25pic1"></div>-->
              <!--                <div class="m-25zt1">总用户数</div>-->
              <!--                <div class="m-25zt2">1000</div>-->
              <!--              </div>-->
              <!--            </div>-->

              <!--              <div class="m-25">-->
              <!--                <div class="m-25k" style="left: 210px">-->
              <!--                  <div class="m-25xz1 m-25pic2"></div>-->
              <!--                  <div class="m-25zt1">常驻户数</div>-->
              <!--                  <div class="m-25zt2" >800</div>-->
              <!--                </div>-->
              <!--              </div>-->

              <!--              <div class="m-25">-->
              <!--                <div class="m-25k" style="left: 400px">-->
              <!--                  <div class="m-25xz1 m-25pic3"></div>-->
              <!--                  <div class="m-25zt1">今日参与数</div>-->
              <!--                  <div class="m-25zt2" >400</div>-->
              <!--                </div>-->
              <!--              </div>-->


              <!--              <div class="m-25">-->
              <!--                <div class="m-25k" style="left: 590px">-->
              <!--                  <div class="m-25xz1 m-25pic4"></div>-->
              <!--                  <div class="m-25zt1">垃圾桶使用数</div>-->
              <!--                  <div class="m-25zt2" >400</div>-->
              <!--                </div>-->
              <!--              </div>-->
              <div class="d-flex">
                <p class="d-flex flex-1"><span>总用户数</span><span class="flex-1"></span><span class="num">{{memberCount.totalMember}}</span>
                </p>
                <p style="width: 80px"></p>
                <p class="d-flex flex-1"><span>常住户数</span><span class="flex-1"></span><span class="num">{{memberCount.czCount}}</span>
                </p>
              </div>
              <div class="d-flex">
                <p class="d-flex flex-1"><span>今日参与户</span><span class="flex-1"></span><span class="num">{{memberCount.todayCount}}</span>
                </p>
                <p style="width: 80px"></p>
                <p class="d-flex flex-1"><span>垃圾桶使用数</span><span class="flex-1"></span><span class="num">{{memberCount.bukCount }}</span>
                </p>
              </div>
            </div>
            <div style="width: 100px"></div>
            <div class="d-flex pies flex-1">
              <Pie :color="'rgba(50,199,9)'" :title="'垃圾分类正确率'" :percentNum="Math.floor(picData.zql)" class="flex-1 pie"></Pie>
              <Pie :color="'rgba(255,153,0)'" :title="'垃圾分类参与率'" :percentNum="Math.floor(picData.cyl)" class="flex-1 pie"></Pie>
              <Pie :color="'rgba(28,212,228)'" :title="'易腐重量/kg'" :percentNum="Math.floor(picData.yfzl)" class="flex-1 pie"></Pie>
            </div>
          </div>
        </div>

        <div class="block-item" style="height: calc(100VH - 400px)">
          <div class="b-map" ref="map" style="width:100%;height:100%;"></div>
          <div class="line-box" ><i class="t-l-line"></i> <i class="l-t-line"></i></div>
          <div class="line-box"><i class="t-r-line"></i> <i class="r-t-line"></i></div>
          <div class="line-box"><i class="l-b-line"></i> <i class="b-l-line"></i></div>
          <div class="line-box"><i class="r-b-line"></i> <i class="b-r-line"></i></div>
        </div>
      </div>

    </div>

    <a-modal title="详细信息" :visible="previewVisible" :footer="null" @cancel="handleCancel"  @close="handleCancel" :width="333">
      <p style="color:#333;">采集姓名:<span style="margin-left: 20px;color:#666;">童美英</span></p>
      <p style="color:#333;">采集地址:<span style="margin-left: 20px;color:#666;">双蔡村金家畈17号</span></p>
      <p style="color:#333;">分类情况：<span style="margin-left: 20px;color:#666;">合格: 40 分</span></p>
      <p style="color:#333;">环保积分:<span style="margin-left: 20px;color:#666;">45 分</span></p>
      <p style="color:#333;">重量:<span style="margin-left: 20px;">0.25 KG</span></p>
      <p style="color:#333;">收集人员:<span style="margin-left: 20px;color:#666;">徐建民</span></p>
      <p style="color:#333;">APP版本号<span style="margin-left: 20px;color:#666;">2.5.7</span></p>
      <p style="color:#333;">收集时间<span style="margin-left: 20px;color:#666;">2019-11-24 11:03:03</span></p>
      <p style="color:#333;">实时图片:<img style="width: 120px;height: 120px;margin-left:20px;" :src="previewImages" /></p>
    </a-modal>

  </div>
</template>

<script>
    import inMap from 'inmap'
    import data from './point.json'
    import styleJson from './mapStyle.json'
    import area from '../../utils/citys'
    import scroll from 'vue-seamless-scroll'
    import Icon from 'ant-design-vue/es/icon'
    import Pie from './Pie'
    import websocket from 'utils/websocket'
    import config from '../../config/index'

    let house = new Image()
    house.src = 'data:image/png;base64,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'

    let car = new Image()
    car.src = 'data:image/png;base64,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'

    let buk = new Image()
    buk.src = 'data:image/png;base64,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'

    export default {
        components: {scroll, Icon, Pie},
        data() {
            return {
                streetList: [],
                memberCount: {totalMember: 0, todayCount: 0, czCount: 0, bukCount: 0},
                chartDate: null,
                series: [],
                chartOptions: {},
                options: area,
                previewVisible:false,
                inmap: null,
                cityName: '',
                province: '全国',
                areaId: null,
                scrollKey: 0,
                city: '',
                text: '',
                totalNum: 0,
                chartHeight: 0,
                previewImages:[] ,
                listData: [],
                picData: {zql: 0, cyl: 0, yfzl: 0},
                lastId: 0,
                carLay: new inMap.ImgOverlay({
                    tooltip: {
                        show: true,
                        formatter: function (params) {
                            return (`<div style="background: #fff;padding: 10px">垃圾车：${params.name}</div>`)
                        },
                        offsets: {top: 15, left: 15},
                        customClass: 'auto'
                    },
                    style: {
                        normal: {icon: car, width: 18, height: 18, offsets: {top: "-50%", left: "-50%"}}
                    },
                    zIndex: 4,
                    data: []
                }),
                bukLay: new inMap.ImgOverlay({
                    tooltip: {
                        show: true,
                        formatter: function (params) {
                            return (
                                `<div style="background: #fff;padding: 10px">垃圾桶：${params.name}</div>`
                            )
                        },
                        offsets: {
                            top: 15,
                            left: 15
                        },
                        customClass: 'auto'
                    },
                    style: {
                        normal: {
                            icon: buk,
                            width: 18,
                            height: 18,
                            offsets: {
                                top: "-100%",
                                left: "-50%"
                            }
                        }
                    },
                    zIndex: 3,
                    data: []
                }),
                streetLay: new inMap.ImgOverlay({
                    tooltip: {
                        show: true, formatter: function (params) {
                            return (`<div style="background: #fff;padding: 10px">小区：${params.name}</div>`)
                        }, offsets: {top: 15, left: 15}, customClass: 'auto'
                    },
                    style: {
                        normal: {
                            icon: house,
                            width: 18,
                            height: 18,
                            offsets: {
                                top: "-100%",
                                left: "-50%"
                            }
                        }
                    },
                    zIndex: 2,
                    data: []
                }),
                overlay: new inMap.PolygonOverlay({
                  tooltip: {
                    show: true,
                    formatter: "{properties.name}"
                  },
                  zIndex: 1,
                  event:{
                    onMouseClick:(item, event,obj)=>{
                      console.info(item,event,obj)
                      let prop = item[0].properties
                      let code = prop.adcode
                      if( prop.level != 'district'){
                        code+='_full'
                      }
                      this.getBoundary(code)

                    }
                  },
                    style: {
                    normal: {
                      borderWidth: 1.5,
                      label: {
                        show: true, // 是否显示
                        font: "12px bold ",
                        color: "#fff"
                      }
                    },
                    mouseOver: {
                      shadowColor: "rgba(0, 0, 0, 1)",
                      shadowBlur: 10,
                      borderWidth: 1.5,
                      label: {
                        color: "rgba(0, 0, 0, 1)"
                      }
                    },

                    colors: [
                      "rgba(0,133,235,0.40)",
                      "rgba(0,184,255,0.40)",
                      "rgba(72,246,217,0.40)",
                      "rgba(252,196,95,0.40)",
                      "rgba(255,132,84,0.40)",
                      "rgba(219,66,90,0.40)"
                    ]
                  }
                })
            }
        },
        methods: {
          // 销毁监听事件
            goMain() {
              document.querySelector('.ant-layout-content').removeAttribute('style')
            },
            showImg(item){
                this.previewImages = item.imgs[0] || 'http://ima.anyuhuanjing.com/upimgs/caijiimgs/201912/1348/15751607983596.jpeg'
                this.previewVisible = true
            },
            handleCancel () {
                this.previewVisible = false
            },
            randomString(len) {
                len = len || 32;
                let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
                /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
                const maxPos = $chars.length;
                let pwd = '';
                for (let i = 0; i < len; i++) {
                    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
                }
                return pwd;
            },
            onDateChange(value, dateString) {
                this.chartDate = dateString
                this.loadAreaData()
            },
            changeStreet(e) {
                this.streetId = e.target.value
                this.lastId = 0
                this.showMapData()
            },
            onCityChange(value, selectedOptions) {
                this.text = selectedOptions.map(o => o.label).join(', ')
                this.cityName = selectedOptions.map(o => o.label).join('')
                this.province = selectedOptions[0].label
                this.city = selectedOptions[1].label
                this.areaId = value[value.length - 1]
                this.lastId = 0
                this.loadStreet()
                this.getBoundary()
                this.showMapData()
                websocket.ws.send(JSON.stringify({code: "CHANGE_AREA", data: {areaId: this.areaId}}))
            },
            loadStreet() {
                this.$post('/data/load_street', {areaId: this.areaId}).then((r) => {
                    this.streetList = r.data.data
                });
            },
            loadRecord() {
                this.$post('/data/check_data', {
                    areaId: this.areaId,
                    lastId: this.lastId,
                    streetId: this.streetId
                }).then((r) => {
                    console.info("check_data", r)
                    let datas
                    if( this.lastId == 0){
                        datas = []
                    }else{
                        datas = this.listData.slice()
                    }
                    let maxId = 0
                    for (let item of r.data.data) {
                        console.info(item)
                        if (maxId < item.id) {
                            maxId = item.id
                        }
                        datas.push({...item, imgs: item.imgs ? JSON.parse(item.imgs) : []})
                    }
                    this.lastId = maxId
                    this.listData = datas
                    if (r.data.data.length >= 20) {
                        this.loadRecord()
                    }

                }).catch(() => {
                })
            },
            loadAreaData(){
                this.$post('/data/area_data', {areaId: this.areaId, streetId: this.streetId,date:this.chartDate}).then((r) => {
                    console.info(r)
                    this.series =  r.data.data.datas
                    this.chartOptions = {
                        chart: {
                            foreColor: '#fff',
                            shadow: {
                                enabled: true,
                                color: '#000',
                                top: 18,
                                left: 7,
                                blur: 10,
                                opacity: 1
                            },
                            toolbar: {
                                show: false
                            }
                        },
                        grid: {
                            borderColor: '#555',
                            clipMarkers: false,
                            yaxis: {
                                lines: {
                                    show: true//显示横线
                                }
                            }
                        },
                        tooltip: {
                            intersect: true,
                            shared: false
                        },
                        dataLabels: {
                            enabled: true
                        },
                        stroke: {
                            curve: 'smooth'
                        },
                        xaxis: {
                            type: 'datetime',
                            categories: r.data.data.categories
                        },
                        tooltip: {
                            x: {
                                format: 'yy-MM-dd'
                            },

                        }
                    }
                })
            },
            showMapData() {
                const {inmap, bukLay, streetLay} = this
                this.listData = []
                this.loadRecord()
                this.loadAreaData()
                this.$post('/data/member_data', {areaId: this.areaId, streetId: this.streetId}).then((r) => {
                    this.memberCount = r.data.data
                })

                this.$post('/data/street_location', {areaId: this.areaId, streetId: this.streetId}).then((r) => {
                    streetLay.setData(r.data.data)
                    inmap.add(streetLay)
                })

                this.$post('/data/buk_location', {areaId: this.areaId, streetId: this.streetId}).then((r) => {
                    bukLay.setData(r.data.data)
                })


                this.$post('/data/check_member_total', {areaId: this.areaId, streetId: this.streetId}).then((r) => {
                    this.totalNum = r.data.data
                })

                this.$post('/data/pic_data', {areaId: this.areaId, streetId: this.streetId}).then((r) => {
                    this.picData = r.data.data
                })
                this.loadCarLocation()
                // let animationOverlay = new inMap.PointAnimationOverlay({
                //   style: {
                //     fps: 25, //动画帧数
                //     color: "#f18080",
                //     size: 10,
                //     speed: 0.4
                //   },
                //   data: []
                // });
                // inmap.add(animationOverlay)


            },
            loadCarLocation() {
                let carLay = this.carLay
                this.$post('/data/car_location', {areaId: this.areaId}).then((r) => {
                    carLay.setData(r.data.data)
                    carLay.refresh()
                    // let i = 0
                    // for (let item of r.data.data) {
                    //     setTimeout(() => {
                    //         carLay.pushData([item])
                    //         carLay.refresh()
                    //     }, i++ * 500)
                    // }
                })
            },
            getBoundary(code) {
                let map = this.inmap.getMap()
                let bdary = new BMap.Boundary()

                let that = this

              this.$get('/data/bound', {code: code}).then((r) => {
                console.info(r)
                let datas = r.data.data.features
                let pointsView = []
                for(let item of datas){
                  let prop = item.properties
                  item['name'] = prop.name;
                  item['count'] = Math.random()*100;
                  let isS =   prop.level == 'district'
                  for(let p of item.geometry.coordinates){
                    for(let pp of p){
                      for(let ppp of pp){
                        if(ppp[0] > 0)
                        pointsView.push(new BMap.Point(ppp[0], ppp[1]))
                      }
                    }
                  }


                  // if(prop.hasOwnProperty("center")){
                  //   if(prop.center instanceof Array){
                  //     pointsView.push(new BMap.Point(prop.center[0], prop.center[1]))
                  //   }else if(prop.center.hasOwnProperty('lng')){
                  //     pointsView.push(new BMap.Point(prop.center['lng'], prop.center['lat']))
                  //   }
                  //
                  // }

                }
                console.info(pointsView)
                map.setViewport(pointsView)

                let overlay = that.overlay
                that.inmap.add(overlay)

                overlay.setData(datas)
                overlay.refresh()
                // map.setMapStyleV2({styleJson: styleJson})
              })
return
                bdary.get(name, function (rs) { //获取行政区域
                    // map.clearOverlays() //清除地图覆盖物
                    let count = rs.boundaries.length //行政区域的点有多少个
                    for (let i = 0; i < count; i++) {
                        let ply = new BMap.Polygon(rs.boundaries[i], {
                            strokeWeight: 2,
                            strokeColor: '#ff0000'
                        }) //建立多边形覆盖物
                        // map.addOverlay(ply); //添加覆盖物
                        map.setViewport(ply.getPath()) //调整视野
                    }
                    // map.zoomIn()
                    let coordinates = []
                    for (let i = 0; i < rs.boundaries.length; i++) {
                        let pointArr = rs.boundaries[i].split(';')
                        let geos = []
                        pointArr.forEach(function (item, index, arr) {
                            var tempArr = item.split(',')
                            var lng = tempArr[0]
                            var lat = tempArr[1]
                            geos.push([parseFloat(lng), parseFloat(lat)])
                        })
                        coordinates.push([geos])

                    }
                    let result = [{
                        geometry: {
                            type: 'MultiPolygon',
                            coordinates: coordinates
                        },
                        count: 1
                    }]

                    let overlay = that.overlay
                    that.inmap.add(overlay)
                    overlay.setData(result)
                    overlay.refresh()
                    console.info(result)
                    //随机设置半径
                    data.forEach(element => {
                        element['style'] = {
                            size: Math.random() * 10
                        }
                    })

                    map.setMapStyleV2({styleJson: [
                        {//不显示点信息
                          'featureType': 'poi',
                          'elementType': 'all',
                          'stylers': {
                            'color': '#ffffff',
                            'visibility': 'off'
                          }
                        },
                        {
                          'featureType': 'road',
                          'elementType': 'all',
                          'stylers': {
                            'color': '#ffffff',
                            'visibility': 'off'
                          }
                        },
                        {
                          'featureType': 'background',
                          'elementType': 'all',
                          'stylers': {
                            'color': '#0000ff'
                          }
                        },
                        {
                          'featureType': 'administrative',
                          'elementType': 'all',
                          'stylers': {
                            'color': '#ffffff',
                            'visibility': 'off'
                          }
                        }
                      ]})
                })
            }
        },


        mounted() {

          document.querySelector('.ant-layout-content').setAttribute('style','z-index:999')

            let topH = this.$refs.chartDiv.offsetHeight;
            this.chartHeight = topH - 60

            const that = this
            window.onresize = () => {
                return (() => {
                    let topH = that.$refs.chartDiv.offsetHeight;
                    that.chartHeight = topH - 60
                    that.scrollKey = that.scrollKey + 1
                })()
            }


            websocket.init(`${config.wsUrl}/websocket/${this.randomString()}`, (evt) => {
                console.info('收到消息:', evt)
                let data = JSON.parse(evt.data)
                if (data) {
                    switch (data.code) {
                        case "CAR_LOCATION_CHANGE":
                            setTimeout(() => {
                                that.loadCarLocation()
                            }, 100)
                            break;
                        case "ADD_CHECK_RECORD":
                            setTimeout(() => {
                                that.lastId = 0
                                that.loadRecord()
                                that.loadAreaData()
                            }, 100)
                            break
                    }
                }
            }, () => {
                websocket.ws.send(["haha"])
            })


            let inmap = new inMap.Map({
                id: this.$refs.map,
                skin: 'Blueness',
                center: [105.403119, 38.028658],
                zoom: {
                    value: 5,
                    show: true,
                    max: 18,
                    min: 5
                },
            })
            this.inmap = inmap
            const {carLay, bukLay, streetLay, overlay} = this

            inmap.add(carLay)
            inmap.add(streetLay)
            inmap.add(bukLay)
            this.showMapData()
            this.getBoundary('100000_full')
        },
        destroyed() {
            websocket.destory()
        }
    }
</script>
<style lang="less" scoped>
.ant-modal-content p {
 text-align: left!important;
}
</style>



// WEBPACK FOOTER //
// src/views/login/Data.vue